<template>
  <div>
    <div>
      <router-link to="/">Home </router-link>
      <label class="labelBar"> / </label>
      <router-link to="/grupoEquipamento"> Cadastro/Equipamento/Grupos </router-link>
      <label class="labelBar"> / </label>
      <label> Criar</label>
    </div>
    <tab-navegacao-equipamento />
    <v-container fluid>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-row align="center">
          <v-col>
            <v-text-field
              label="Grupo *"
              v-model="descricao"
              v-uppercase
              :counter="200"
              :rules="[(v) => !!v || 'O nome do grupo é obrigatório']"
              required
            ></v-text-field>
          </v-col>
        </v-row>
      </v-form>
      <v-row align="center-left">
        <v-col class="text-right">
          <v-btn to="/grupoEquipamento" color="error" class="mr-4"> Voltar </v-btn>
          <v-btn @click="enviar" color="success" class="mr-4"> Salvar </v-btn>
        </v-col>
      </v-row>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-container>
  </div>
</template>

<script>
import TabNavegacaoEquipamento from "../../Tabs/TabCadastroEquipamento";
import { enviarFamiliaAsync } from "../../../services/familiaService";

export default {
  name: "criarFamilia",
  data: () => ({
    overlay: false,
    valid: true,
    descricao: null,
  }),
  methods: {
    async enviar() {
      if (this.$refs.form.validate()) {
        this.overlay = true;
        const resposta = await enviarFamiliaAsync(this.descricao);
        if (resposta) {
          //this.mensagemErro = resposta;
          //this.mostartMensagemErro = true;
          this.overlay = false;
          this.$alert(resposta.message, "Descupe, falha na operação!", "error");
        } else {
          this.overlay = false;
          this.$router.push("/grupoEquipamento");
        }
      }
    },
  },
  components: {
    TabNavegacaoEquipamento,
  },
};
</script>
